var map = {
	"./AddNote.svg": "8091",
	"./EditNote.svg": "f56a",
	"./arrow-r-dist.svg": "f1f0",
	"./arrow-right-w.svg": "f6c5",
	"./avn/bulb-education-idea.svg": "9c1e",
	"./avn/drugs.svg": "4f6c",
	"./avn/promotions-promotion.svg": "5521",
	"./bell-ringing.svg": "e0e9",
	"./box-dist.svg": "a12d",
	"./calendar.svg": "d71f",
	"./certified.svg": "b0de",
	"./check.svg": "51c7",
	"./clock-circle-svgrepo-com.svg": "650f",
	"./clock-dist.svg": "f1a7",
	"./close-circle.svg": "933e",
	"./close.svg": "2930",
	"./deal-svgrepo-com.svg": "6f2e",
	"./delivery-truck.svg": "1a94",
	"./dist/eye-off.svg": "aac0",
	"./dist/eye.svg": "b9ad",
	"./dist/frame.svg": "d2f6",
	"./document-medicine.svg": "f2a7",
	"./double-arrow-left.svg": "9a0f",
	"./double-arrow-right.svg": "0906",
	"./download-success.svg": "973a",
	"./drugs-pharmacy.svg": "f150",
	"./fb-dist.svg": "ecb1",
	"./globe.svg": "5cb9",
	"./health-insurance.svg": "65cc",
	"./in-progress.svg": "efe7",
	"./insta-dist.svg": "ad1f",
	"./key.svg": "f4a8",
	"./link-dist.svg": "988d",
	"./lock.svg": "d3cc",
	"./mail-dist.svg": "25c5",
	"./mail-w.svg": "abbf",
	"./mail.svg": "999f",
	"./marker-pin-pr.svg": "26ed",
	"./marker-w.svg": "b57d",
	"./on-line-dist.svg": "7f8e",
	"./phone-dist.svg": "c277",
	"./phone-w.svg": "709d",
	"./pills.svg": "2902",
	"./position-dist.svg": "7e99",
	"./rule-draft.svg": "525c",
	"./stethoscope.svg": "6c10",
	"./truck-dist.svg": "f420",
	"./twiter-dist.svg": "d785",
	"./verified-check.svg": "100a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";